// components/Timer.js
import React from 'react';
import Countdown from 'react-countdown'; // Import the Countdown component
import './institute-Plans.css';

const Timer = ({ startDate, endDate }) => {
  // Ensure that the start and end dates are valid Date objects
  const start = new Date(startDate);  // Convert start date to timestamp
  const end = new Date(endDate);      // Convert end date to timestamp

  // Check if both start and end dates are valid
  if (isNaN(start) || isNaN(end)) {
    return <div>Error: Invalid dates.</div>;
  }

  return (
    <div className="timer-container">
      <div className="timer-text">
        <h2>خطة المعهد</h2>
        <p>لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم.</p>
      </div>
      <div className="timer">
        {/* Countdown to end date */}
        {new Date() < start && (
        <div className="start-countdown">
          <Countdown
            date={start}
            renderer={({ days, hours, minutes, seconds }) => (
              <div className="time-display">
                <div className="time">
                  <span>{String(days).padStart(2, '0')}</span>
                  <span>يوم</span>
                </div><b>:</b>
                <div className="time">
                  <span>{String(hours).padStart(2, '0')}</span>
                  <span>ساعة</span>
                </div><b>:</b>
                <div className="time">
                  <span>{String(minutes).padStart(2, '0')}</span>
                  <span>دقيقة</span>
                </div><b>:</b>
                <div className="time">
                  <span>{String(seconds).padStart(2, '0')}</span>
                  <span>ثانية</span>
                </div>
              </div>
            )}
          />
        </div>
      )}
      </div>
     
      
    </div>
  );
};

export default Timer;
